import { gql } from 'apollo-angular';
import { IssueStatus } from '../../entities/issue/issue-status';

export const GET_STATUSES_QUERY = gql`
  query getIssueStatuses {
    getIssueStatuses {
      code
      label
    }
  }
`;

export interface GetIssueStatusesResponse {
  getIssueStatuses: IssueStatus[];
  loading: boolean;
}
